import { render } from "./Nothing.vue?vue&type=template&id=b1f62a58&scoped=true"
import script from "./Nothing.vue?vue&type=script&lang=js"
export * from "./Nothing.vue?vue&type=script&lang=js"

import "./Nothing.vue?vue&type=style&index=0&id=b1f62a58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f62a58"]])

export default __exports__